import { render, staticRenderFns } from "./new_list.vue?vue&type=template&id=3ae7c28c&scoped=true&"
import script from "./new_list.vue?vue&type=script&lang=js&"
export * from "./new_list.vue?vue&type=script&lang=js&"
import style0 from "./new_list.vue?vue&type=style&index=0&id=3ae7c28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae7c28c",
  null
  
)

export default component.exports